var r={worth:"Worth"};export{r as bundleItemTranslations};
